// extracted by mini-css-extract-plugin
module.exports = {"infoButton":"SaveNewCardCheckbox__infoButton___1kv3A","infoImage":"SaveNewCardCheckbox__infoImage___1DdCW"};